import { SaleChannel } from '@/constants'
import { useAuth } from '@/containers'
import type { Property, PropertyValue } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import { type ReactNode } from 'react'

interface ProductSpecificationsProps {
  specifications: Property[]
}

export const ProductSpecificationsModal = ({
  specifications,
}: ProductSpecificationsProps) => {
  const { token, user } = useAuth()

  const specificationsData = specifications?.filter(
    item => !item?.policy && item?.channels?.includes(SaleChannel.B2C)
  )

  const specificationsDataB2E = specifications?.filter(
    item => !item?.policy && item?.channels?.includes(SaleChannel.B2E)
  )

  const renderSpecificationsItem = (item: Property): ReactNode => {
    switch (item.type as string) {
      case 'multipleSelect':
        return item.values.map((e: PropertyValue) => {
          return (
            <span
              key={e._id}
              className="mr-1 block after:content-[','] last:mr-0 last:after:content-[unset]"
            >
              {getTranslate(e.value)}
            </span>
          )
        })

      case 'singleSelect':
        return item.values.map((e: PropertyValue) => {
          return (
            <span
              className="mr-1 inline-block after:content-[','] last:mr-0 last:after:content-[unset]"
              key={e._id}
            >
              {getTranslate(e.value)}
            </span>
          )
        })

      case 'input':
        return <span>{getTranslate(item.value)}</span>
      default:
        break
    }
  }

  const renderSpecificationsData =
    token && user?.saleChannel === SaleChannel.B2E
      ? specificationsDataB2E
      : specificationsData

  return (
    <div className='mt-3'>
      {renderSpecificationsData.map((item, index) => {
        if (getTranslate(item.value) != '' || item.values.length > 0) {
          return (
            <div
              key={index}
              className='flex w-full flex-wrap justify-center bg-[#F7F8F8] px-4 py-2 nth-2n:bg-white'
            >
              <span className='label line-clamp-1 block max-w-[40%] flex-40 overflow-hidden text-ellipsis text-sm font-semibold leading-[20px] text-[#010103]'>
                {getTranslate(item.name)}
              </span>
              <span className='value flex w-full max-w-[60%] flex-60 text-sm leading-[20px] text-[#010103]'>
                {renderSpecificationsItem(item)}
              </span>
            </div>
          )
        }
      })}
    </div>
  )
}

export default ProductSpecificationsModal
